const delimiter = ' | ';

export { delimiter };